import { render, staticRenderFns } from "./ShortlistModalHeader.vue?vue&type=template&id=4c72efb8&"
import script from "./ShortlistModalHeader.vue?vue&type=script&lang=js&"
export * from "./ShortlistModalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports